import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "event",
  "use": "event-usage",
  "viewBox": "0 0 40 48",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 48\" id=\"event\"><path d=\"M26 30v11.036a5.464 5.464 0 01-5.466 5.464H7.466A5.464 5.464 0 012 41.036V9.966A5.466 5.466 0 017.466 4.5H14m-12 33h24m1.5-36A7.5 7.5 0 0135 9v6a3 3 0 003 3H17a3 3 0 003-3V9a7.5 7.5 0 017.5-7.5z\" stroke=\"currentColor\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/event.svg
// module id = LoQK
// module chunks = 39 44